import { Injectable } from '@angular/core';
import { format, isBefore, differenceInMinutes } from 'date-fns';

const DateFormatsClass = {
  dateTimeWithOrdinalTime: 'h:mm A, MMMM do',
  dateTimeWithOrdinalMonthShorterned: 'MMM. do, h:mm a',
  dateTimeWithOrdinalTimeFull: 'MMMM do, h:mm a',
  timeOnly: 'h:mm a'
};

const dateMayDot = 'May.';
const dateMayNoDot = 'May';

@Injectable()
export class TimeFormatService {
  constructor() { }



  /**
   * method to get the time as per the format required
   * @method getFormattedTime
   * @param date
   * @param formatter
   * @return formattedDate
   */
  public getFormattedDate(date: Date | string, formatter: string): string {
    const fromDate = (date instanceof Date) ? date : new Date(date);
    if (typeof date === 'string' && isNaN(new Date(date).valueOf())) {
      return String(date);
    }
    return format(fromDate, DateFormatsClass[formatter]);
  }

  /**
  * method to check if the input date is before the date provided for comparision
  * @method isBefore
  * @param inputDate
  * @param compareDate
  * @return boolean
  */
  public isBefore(inputDate: Date | string, compareDate: Date | string): boolean {
    const leftDate = (inputDate instanceof Date) ? inputDate : new Date(inputDate);
    if (typeof inputDate === 'string' && isNaN(new Date(inputDate).valueOf())) {
      return null;
    }
    const rightDate = (compareDate instanceof Date) ? compareDate : new Date(compareDate);
    if (typeof compareDate === 'string' && isNaN(new Date(compareDate).valueOf())) {
      return null;
    }

    return isBefore(leftDate, rightDate);
  }

  /**
  * method to check if the input date is valid return month's character length
  * @method returnFormattedDate
  * @param inputDate
  * @return string
  */
  public returnFormattedDate( inputDate: Date | string): string {
    let tempDate: string;
    tempDate = this.getFormattedDate(inputDate, 'dateTimeWithOrdinalMonthShorterned');
    tempDate = tempDate.replace(dateMayDot, dateMayNoDot);
    return tempDate;
  }
  /**
  * method to check if the input date is valid return month's character length
  * @method returnFormattedDateFull
  * @param inputDate
  * @return string
  */
  public returnFormattedDateFull( inputDate: Date | string): string {
    return this.getFormattedDate(inputDate, 'dateTimeWithOrdinalTimeFull');
  }

  /**
   * method to return the minute difference
   * @method getMinuteDiff
   * @param maxDate
   * @param minDate
   * @returns
   */
  public getMinuteDiff(maxDate: Date | string, minDate: Date | string): number {
    const largerDate = (maxDate instanceof Date) ? maxDate : new Date(maxDate);
    if (typeof maxDate === 'string' && isNaN(new Date(maxDate).valueOf())) {
      return NaN;
    }
    const smallerDate = (minDate instanceof Date) ? minDate : new Date(minDate);
    if (typeof minDate === 'string' && isNaN(new Date(minDate).valueOf())) {
      return NaN;
    }
    return differenceInMinutes(largerDate, smallerDate);
  }
}
